<template>
  <div class="audit-logs-container" v-if="auditLogs.length">
    <div class="audit-logs-header">
      <div>Author</div>
      <div>Created On</div>
      <div>Type</div>
    </div>
    <div class="audit-logs">
      <div v-for="(auditLog, index) in auditLogs" :key="index" class="audit-log" @click="selectAuditLog(auditLog.type)">
        <div>{{ auditLog.author }}</div>
        <div>{{ auditLog.createdOn | date('dd-MM-yyyy HH:mm:ss') }}</div>
        <div>{{ getSectionType(auditLog.type) }}</div>
      </div>
    </div>
    <button v-if="canShowMoreAuditLogs" @click="showMore" class="btn btn-primary float-end">
      Show more
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['auditLogs', 'canShowMoreAuditLogs', 'sections'])
  },
  created() {
    this.$store.dispatch('getAuditLogs')
  },
  destroyed() {
    this.$store.commit('clearAuditLogs')
  },
  methods: {
    showMore() {
      this.$store.dispatch('getAuditLogs', true)
    },
    selectAuditLog(selectedType) {
      const sectionType = this.getSectionType(selectedType)
      const settings = this.sections.sectionLevels.find(level => level.key === 'Settings')
      const sectionToSet =
        settings.sections.find(section => section.key.includes(sectionType)) ||
        settings.subSections.flatMap(subSection => subSection.sections).find(section => section.key.includes(sectionType))

      if (sectionToSet) {
        this.$store.commit('setAuditLogSelected')
        this.$store.commit('setCurrentSection', sectionToSet)
        return
      }

      this.$store.dispatch('showMessage', {
        title: 'Audit Logs',
        type: 'error',
        text: 'Something went wrong while navigating to the History page'
      })
    },
    getSectionType(type) {
      return type.replace('_Values', '')
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .audit-logs-container {
    margin-left: 10px;
    margin-right: 10px;
  }
}
.audit-logs-header {
  display: flex;
  justify-content: space-between;
  text-align: center;
  color: var(--bs-body-color);
  background-color: var(--bs-dark-bg-subtle);
  font-weight: bold;
}
.audit-logs-header > div {
  flex: 1 1 0;
  padding-top: 12px;
  padding-bottom: 12px;
}
.audit-logs {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.audit-log {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 3px;
  word-break: break-word;
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  border-radius: 5px;
  cursor: pointer;
}
.audit-log:hover {
  background-color: var(--bs-dark-bg-subtle);
}
.audit-log > div {
  flex: 1 1 0;
  padding: 10px;
}
@media (max-width: 768px) {
  .audit-log > div {
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AuditLogs.vue